module.exports = __webpack_public_path__ + "static/media/minus.d6f7642b.svg";